<template>
    <v-container fluid>
        <h2 class="subheading grey--text">{{$t('entrada_salida_no_code')}}</h2>
        <!-- Diálogo modal Persistente para seleccionar la Caseta -->
        <v-dialog v-model="dialog_inicio" persistent max-width="400px">
            <v-form @submit.prevent="set_caseta()">
                <v-card class="justify-center">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('selecciona_caseta')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-autocomplete
                                v-model="caseta"
                                name="caseta"
                                :items="casetas"
                                item-text="nombre"
                                item-value="id"
                                :label="$t('Casetas')"
                        ></v-autocomplete>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                type="submit"
                        >{{ $t('aceptar') }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <v-card
                width="900"
                class="mx-auto elevation-7"
        >
            <v-toolbar dark color="primary">
                <v-toolbar-title>
                    {{$t('entrada_salida_no_code')}}
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <v-layout  row wrap class="text-xs-center">
                    <v-flex>
                        <p class="text-xs-center">{{$t('msg_access_no_code')}}</p>
                    </v-flex>
                </v-layout>
                <v-layout  row wrap class="text-xs-center">
                    <v-flex xs6>
                        <v-layout justify-center class="text-xs-center edge pt-3 pb-3 pl-3 pr-3" row wrap>
                            <v-flex xs12>
                                <h3>{{$t('select_video_device')}}</h3>
                                <select v-model="camera">
                                    <option>{{$t('select_video_device')}}</option>
                                    <option
                                            v-for="device in devices"
                                            :key="device.deviceId"
                                            :value="device.deviceId">
                                        {{ device.label }}
                                    </option>
                                </select>
                                <v-img
                                        width="100%"
                                        :src="img !== '' ? img : require('../../assets/sin-foto.png')"
                                >
                                    <v-layout row wrap>
                                        <v-flex class="text-xs-left">
                                            <v-avatar
                                                    class="profile"
                                                    color="grey"
                                                    size="164"
                                                    tile
                                            >
                                                <div v-show="band" @click="onCapture()">
                                                    <vue-web-cam
                                                            ref="webcam"
                                                            :device-id="deviceId"
                                                            width="100%"
                                                            @started="onStarted"
                                                            @stopped="onStopped"
                                                            @error="onError"
                                                            @cameras="onCameras"
                                                            @camera-change="onCameraChange"
                                                    />
                                                </div>
                                            </v-avatar>
                                        </v-flex>
                                    </v-layout>
                                </v-img>
                            </v-flex>
                            <br>
                            <v-alert
                                    :value="errores.url_foto"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                {{errores.url_foto}}
                            </v-alert>
                            <br>
                            {{$t('msg_captura_foto')}}
                        </v-layout>
                    </v-flex>
                    <v-flex xs6 class="text-xs-center pt-3 pb-3 pl-3 pr-3">
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-autocomplete
                                        v-model="id_area"
                                        prepend-icon="location_city"
                                        name="id_area"
                                        item-text="nombre"
                                        item-value="id"
                                        :label="$t('Area')"
                                        :filter="customFilterArea"
                                        :error-messages="errores.id_area"
                                        :items="areas"
                                        :no-data-text="$t('no_resultados')"
                                        clearable
                                >
                                </v-autocomplete>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="nombre"
                                        prepend-icon="person_outline"
                                        name="nombre"
                                        :label="$t('nombre')"
                                        :error-messages="errores.nombre"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <v-text-field
                                        v-model="notas"
                                        prepend-icon="notes"
                                        name="notas"
                                        :label="$t('Notas')"
                                        :error-messages="errores.notas"
                                >
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-alert
                                :value=alerta
                                type="warning"
                                outline
                                transition="scale-transition"
                        >
                            Fallo con el Servidor
                        </v-alert>
                    </v-flex>
                </v-layout>
                <div align="center">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <div v-on="on">
                                <v-btn
                                        :disabled="img === ''"
                                        large
                                        color="primary"
                                        @click="alta_sin_codigo()"
                                        :loading="loading"
                                >{{$t('enviar')}}
                                </v-btn>
                            </div>
                        </template>
                        <span>{{img === '' ? $t('msg_must_capture_photo') : $t('enviar')}}</span>
                    </v-tooltip>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    import { WebCam } from "vue-web-cam"
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    Vue.use(VeeValidate)
    import { mapState } from 'vuex'


    export default {
        name: "acceso_sin_codigo",
        components: {
            "vue-web-cam": WebCam
        },
        data() {
            return {
                img: '',
                camera: null,
                deviceId: null,
                devices: [],
                id_empleado: '',
                id_area: '',
                nombre: '',
                telefono: '',
                empresa: '',
                notas: '',
                errores: [],
                areas: [],
                empleados: [],
                loading: false,
                alerta: '',
                dialog_inicio: false,
                casetas: [],
                caseta: 0,
                band: false

            };
        },
        computed: {
            ...mapState(['language']),
            device () {
                return this.devices.find(n => n.deviceId === this.deviceId)
            }
        },
        created: function(){
            this.get_areas()
            this.get_casetas()
            if(localStorage.getItem('id_caseta') === null){
                this.dialog_inicio = true
            }
        },
        watch: {
            camera: function(id) {
                this.deviceId = id;
            },
            devices () {
                // Once we have a list select the first one
                const [first, ...tail] = this.devices
                if (first) {
                    this.camera = first.deviceId
                    this.deviceId = first.deviceId
                }else {
                    this.camera = tail.deviceId
                    this.deviceId = tail.deviceId
                }
            }
        },
        methods: {
            onCapture() {
                this.img = this.$refs.webcam.capture();
            },
            onStarted(stream) {
                this.band = true
                console.log("On Started Event", stream);
            },
            onStopped(stream) {
                console.log("On Stopped Event", stream);
            },
            onStop() {
                this.$refs.webcam.stop();
            },
            onStart() {
                this.$refs.webcam.start();
            },
            onError(error) {
                console.log("On Error Event", error)
            },
            onCameras(cameras) {
                this.devices = cameras
                console.log("On Cameras Event", cameras)
            },
            onCameraChange(deviceId) {
                this.deviceId = deviceId
                this.camera = deviceId
                console.log("On Camera Change Event", deviceId)
            },
            dataURLtoFile(dataurl, filename) {
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            alta_sin_codigo () {
                this.loading = true
                this.errores = []
                var bodyFormData = new FormData()
                var fileImageFront = null
                const newID = this.$uuid.v4()

                bodyFormData.set('id_area', this.id_area)
                bodyFormData.set('id_caseta', localStorage.getItem('id_caseta'))
                bodyFormData.set('nombre', this.nombre)
                bodyFormData.set('notas', this.notas)
                if (this.img !== '' && this.img.length > 6) {
                    fileImageFront = this.dataURLtoFile(this.img, 'picture' + newID + '.png')
                }
                bodyFormData.append('url_foto', fileImageFront)
                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/bitacora_express/',
                    headers: {
                        'Content-Type': 'multipart/form-data',
                        'authorization': 'Token ' + store.getters.getToken,
                        'Accept-Language': this.language,
                    },
                    data: bodyFormData
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_color', 'success')
                        this.$store.commit('snackbar_change_message', this.$t('mensaje_alta_acceso_without'))
                        setTimeout(this.clear, 3000)
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                        else
                        if(error.response.status == 404)
                        {
                            this.$store.commit('snackbar_activate_true')
                            this.$store.commit('snackbar_change_color', 'error')
                            this.$store.commit('snackbar_change_message', 'Token Inválido')
                            setTimeout(this.clear, 3000)
                        }
                    })
                    .finally(() => (this.loading = false))

            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.clean_fields()
            },
            clean_fields(){
                this.img = ''
                this.id_empleado = ''
                this.id_area = ''
                this.nombre = ''
                this.telefono = ''
                this.empresa = ''
                this.notas = ''
            },
            get_areas: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/areas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.areas = response.data

                        console.log(this.id_empresa)
                    })
                    .catch(error => {
                        console.log(error)
                    })

            },
            customFilterArea (item, queryText) {
                const textOne = item.nombre.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            },
            set_caseta: function(){
                if(this.caseta > 0){
                    localStorage.setItem('id_caseta', this.caseta)
                    this.dialog_inicio = false
                }
            },
            get_casetas: function(){
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/casetas/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.casetas = response.data
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }
    };
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        border-style: solid solid solid solid;
    }
</style>
